import { HttpClient, queryString } from '@opallabs/api'
import loadAssetCSVRowCount from '../loadAssetCSVRowCount'

// update with accurate request when available
const fetchCount = (params) => {
  const formattedParams = {
    ...params,
    filter_attributes: JSON.stringify(params.filter_attributes),
  }
  const url = new URL('/api/v1/asset_references', window.location.origin)
  url.search = queryString(formattedParams)
  return HttpClient().get(url.toString())
}

const getAssetCSVRowCount = (params) => (dispatch) =>
  fetchCount(params)
    .then((response) => dispatch(loadAssetCSVRowCount(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getAssetCSVRowCount
